/*
 * @Author: Czy
 * @Date: 2024-12-18 15:49:45
 * @FilePath: /bikecat/src/store/order.ts
 *
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { MessageDto } from '@/service/order/order.d'

import { PlatformDTO } from '@/service/hotel/hotel.d'
export const useOrderStore = defineStore(
  'order',
  () => {
    const orderMarker = ref<string>('') // 订单确认页备注
    const showSubMessage = ref<boolean>(false)
    const subMessageData = ref<MessageDto>({
      message: '',
      orderId: '',
      title: '',
    })
    const platformList = ref<PlatformDTO[]>([])

    /**
     * 根据字段名和bizCode获取平台信息
     * @param field 要获取的字段名 ('logo' | 'platformName')
     * @param bizCode 平台业务编码
     * @returns 对应字段的值，如果未找到返回默认值
     */
    const getPlatformField = (field: 'logo' | 'platformName', bizCode: string): string => {
      const DEFAULT_LOGO = 'https://hx-mp-res.hitrips.cn/erp/0eb7bb8a3b31479b97bf6062c314360c.jpg'

      if (!platformList.value) {
        return field === 'logo' ? DEFAULT_LOGO : '-'
      }

      const platform = platformList.value.find((item) => item.bizCode === bizCode)

      if (!platform || !platform[field]) {
        return field === 'logo' ? DEFAULT_LOGO : '-'
      }

      return platform[field] as string
    }

    return {
      orderMarker,
      showSubMessage,
      subMessageData,
      platformList,
      getPlatformField,
    }
  },
  {
    persist: false,
  },
)
